import { CheckIcon } from "@heroicons/react/24/solid";
import { PropsWithoutRef } from "react";

export const Fact = ({
  text,
  description,
}: PropsWithoutRef<{
  text: string;
  description: string;
}>) => {
  return (
    <li className="flex gap-1">
      <div>
        <CheckIcon className="h-6 w-6 text-indigo-600" />
      </div>
      <div>
        <p className="mb-1 text-lg font-bold text-indigo-700">{text}</p>
        <span className="font-regular text-md">{description}</span>
      </div>
    </li>
  );
};
